import {ConfigurationContract} from 'common/tool/ConfigurationContract';
import {FileSystemContract} from 'common/tool/FileSystemContract';
import {FileSystem} from 'common/tool/FileSystem';
import {Env} from 'common/tool/Env';
import {merge} from 'lodash';
import {Environment} from 'common/tool/Environment';

export class Configuration implements ConfigurationContract {
    private static config: any;
    private static root: string;
    private static environment: Env;
    private readonly filesystem: FileSystemContract;

    public constructor(root: string, environment?: Env) {
        this.filesystem = new FileSystem();
        if (Configuration.root === undefined || Configuration.root !== root) {
            Configuration.root = root;
            Configuration.config = undefined;
        }
        const currentEnvironment: string = (environment === undefined ? Environment.getMode() : environment);
        if (Configuration.environment === undefined || Configuration.environment !== currentEnvironment) {
            Configuration.environment = environment === undefined ? Environment.getMode() : environment;
            Configuration.config = undefined;
        }
    }

    public async full(): Promise<any> {
        await this.init();

        return Configuration.config;
    }

    private async init(): Promise<void> {
        if (Configuration.config === undefined) {
            if (Configuration.root === undefined) {
                Configuration.config = {};
            } else {
                Configuration.config = await this.filesystem.readJson(Configuration.root + 'data/config.json');
                if ([Env.DEVELOPMENT, Env.TEST].includes(Configuration.environment)) {
                    try {
                        Configuration.config = merge(Configuration.config, await this.filesystem.readJson(Configuration.root + 'data/config_' + String(Configuration.environment) + '.json'));
                    } catch (_e) {
                        // nothing
                    }
                }

            }
        }
    }
}
